import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CampaignMiniBanner from '../../components/feature/CampaignMiniBanner';
import CoworkingHero from './components/CoworkingHero';
import CoworkingBenefits from './components/CoworkingBenefits';
import CoworkingFacilities from './components/CoworkingFacilities';
import CoworkingEquipment from './components/CoworkingEquipment';
import CoworkingGallery from './components/CoworkingGallery';
import CoworkingPricing from './components/CoworkingPricing';
import CoworkingFAQ from './components/CoworkingFAQ';
import CoworkingPartner from './components/CoworkingPartner';
import CoworkingAccess from './components/CoworkingAccess';
import CoworkingCTA from './components/CoworkingCTA';
import StickyBookingBar from './components/StickyBookingBar';

export default function CoworkingExperience() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // Ensure we start at the top when the component mounts
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }

    const handleScroll = () => {
      try {
        setScrolled(window.scrollY > 50);
      } catch (e) {
        console.error('Error handling scroll event:', e);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    // Cleanup listener on unmount
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <div className="relative">
      <Navbar scrolled={scrolled} />
      <div className="pt-16 sm:pt-20">
        <CampaignMiniBanner />
      </div>
      <main>
        <CoworkingHero />
        <CoworkingBenefits />
        <CoworkingFacilities />
        <CoworkingEquipment />
        <CoworkingGallery />
        <CoworkingPricing />
        <CoworkingFAQ />
        <CoworkingPartner />
        <CoworkingAccess />
        <CoworkingCTA />
      </main>
      <Footer />
      <StickyBookingBar />
    </div>
  );
}
